var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "listagem-conversas" } },
    [
      _c("p", { staticClass: "bolder" }, [_vm._v("Listagem de Conversas")]),
      _c(
        "el-card",
        { attrs: { shadow: "hover" } },
        [
          _c("p", { staticClass: "bolder" }, [_vm._v("Filtros")]),
          _c(
            "el-row",
            { staticClass: "margin-left" },
            [
              _c(
                "el-col",
                { attrs: { xs: 12, lg: 7, xl: 5, sm: 10 } },
                [
                  _c("InputEntreDatas", {
                    attrs: {
                      placeholder: "Período",
                      calendario: _vm.calendario
                    },
                    model: {
                      value: _vm.calendario,
                      callback: function($$v) {
                        _vm.calendario = $$v
                      },
                      expression: "calendario"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 9, xl: 6, sm: 13 } },
                [
                  _c("p", [_vm._v("Assunto")]),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "24rem" },
                      attrs: {
                        filterable: "filterable",
                        clearable: "clearable",
                        multiple: "multiple",
                        "collapse-tags": "collapse-tags"
                      },
                      model: {
                        value: _vm.filtro.assunto,
                        callback: function($$v) {
                          _vm.$set(_vm.filtro, "assunto", $$v)
                        },
                        expression: "filtro.assunto"
                      }
                    },
                    _vm._l(_vm.assuntos, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 8, xl: 4, sm: 10 } },
                [
                  _c("p", [_vm._v("Responsável")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "multiple",
                        "collapse-tags": "collapse-tags",
                        filterable: "filterable",
                        clearable: "clearable"
                      },
                      model: {
                        value: _vm.filtro.idsResponsaveis,
                        callback: function($$v) {
                          _vm.$set(_vm.filtro, "idsResponsaveis", $$v)
                        },
                        expression: "filtro.idsResponsaveis"
                      }
                    },
                    _vm._l(_vm.responsaveis, function(item) {
                      return _c("el-option", {
                        key: item.pessoa.pessoaFisica.id,
                        attrs: {
                          label: item.pessoa.pessoaFisica.nome,
                          value: item.pessoa.pessoaFisica.id
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 7, xl: 5, sm: 12 } },
                [
                  _c("p", [_vm._v("Interessado")]),
                  _c("el-input", {
                    staticStyle: { width: "18.5rem" },
                    model: {
                      value: _vm.filtro.nomeInteressados,
                      callback: function($$v) {
                        _vm.$set(_vm.filtro, "nomeInteressados", $$v)
                      },
                      expression: "filtro.nomeInteressados"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { xs: 24, lg: 6, xl: 4, sm: 13 } },
                [
                  _c("p", [_vm._v("Status")]),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "multiple",
                        "collapse-tags": "collapse-tags",
                        filterable: "filterable",
                        clearable: "clearable"
                      },
                      model: {
                        value: _vm.filtro.status,
                        callback: function($$v) {
                          _vm.$set(_vm.filtro, "status", $$v)
                        },
                        expression: "filtro.status"
                      }
                    },
                    _vm._l(_vm.status, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "margin float" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text", size: "medium", round: "round" },
                  on: { click: _vm.handleLimpar }
                },
                [_vm._v("Limpar")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "medium", round: "round" },
                  on: { click: _vm.handleFiltrar }
                },
                [_vm._v("Filtrar")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "cards" },
        [
          _c("CardDashboard", {
            attrs: {
              content: _vm.totalConversas,
              title: "Total de conversas",
              icon: "far fa-comments",
              color: "#00537e"
            }
          }),
          _c("CardDashboard", {
            attrs: {
              title: "Encerradas",
              content: _vm.finalizadas,
              icon: "far fa-calendar-check",
              color: "blue"
            }
          }),
          _c("CardDashboard", {
            attrs: {
              title: "Respondidas",
              content: _vm.respondidas,
              icon: "far fa-comment-check",
              color: "green"
            }
          }),
          _c("CardDashboard", {
            attrs: {
              title: "Aguardando resposta",
              content: _vm.aguardandoResposta,
              icon: "far fa-alarm-exclamation",
              color: "yellow"
            }
          })
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticClass: "margin-top",
          attrs: {
            data: _vm.dadosTabela,
            "empty-text": "Não há dados registrados"
          }
        },
        _vm._l(_vm.nomeColunas, function(item) {
          return _c("el-table-column", {
            key: item.prop,
            attrs: { sortable: "sortable", prop: item.prop, label: item.label }
          })
        }),
        1
      ),
      _c("app-paginacao", {
        attrs: { total: _vm.totalConversas, pagina: 1 },
        on: { changePage: _vm.alterarPagina }
      }),
      _c(
        "el-row",
        { staticClass: "botao-exportar float" },
        [
          _c("BotaoExportarSelecionado", {
            attrs: {
              dadosFiltro: _vm.filtro,
              selecionadoCondicao: false,
              disabled: _vm.botaoExportarDesligado,
              tab: "listagemConversas"
            },
            on: { "exportar-csv-tabela": _vm.exportarCsvTabela }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a7eba9a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7eba9a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios_ouvidoria/ListagemConversas.vue
// module id = null
// module chunks = 